module.exports = __webpack_public_path__ + "img/brazao 1.5ac3b23f.svg";